import React, { useState } from "react";
import axios from "axios";
import Cookies from "universal-cookie";
import { APP_URL } from "../../Config/AppConfiguration";
import login from "./Login";
import { toast } from 'react-toastify';
import ErrorPage from "../../Layouts/Main/ErrorPage";

let apimErrorShown = false;
let lastApimError = null;
let lastApimErrorTime = 0;

const AppAuthentication = () => {
  const cookies = new Cookies();
 
  const [showErrorPage, setShowErrorPage] = useState(false);

  const cookieNameUser = "userId";
  const cookieNameToken = "accessToken";
  const cookieNameCurrentUser = "currentAPIMUser";

  const flushActiveSession = async () => {
    sessionStorage.clear();
  };

  const clearCookiesAndSession = async () => {
    if (cookies.get(cookieNameToken) !== null) {
      cookies.remove(cookieNameToken);
      cookies.remove(cookieNameUser);
      cookies.remove(cookieNameCurrentUser);
    }
    await flushActiveSession();
  };

  axios.interceptors.request.use((config) => {
    if (config.url.includes(APP_URL)) {
      const token = cookies.get("accessToken");
      config.headers.Authorization = token ? `Bearer ${token}` : "";
    }
    return config;
  });

    axios.interceptors.response.use(
      (response) => {
        return response;
      },
      (error) => {
        if (error.response?.status === 401) {
          // Ignore 401 for error page, handle as before
          clearCookiesAndSession();
          alert(
            "Your access token has expired, you will be re-directed to the login page"
          );
          window.location.href = login.getLoginUrl();
        }
        // Handle APIM-5000 error
        else if (error.response?.data?.code === "APIM-5000") {
          if (!apimErrorShown) {
            toast.warn(error.response.data.message);
            apimErrorShown = true;
          }
          //setShowErrorPage(true);
        }
        // Handle APIM errors (code starts with "APIM-")
        else if (
          error.response?.data?.code &&
          error.response.data.code.startsWith("APIM-")
        ) {
          const currentTime = Date.now();
          const errorMessage = error.response.data.message;
          
          // Prevent duplicate APIM error toasts within 1 second
          if (lastApimError !== errorMessage || currentTime - lastApimErrorTime > 1000) {
            toast.warn(errorMessage);
            lastApimError = errorMessage;
            lastApimErrorTime = currentTime;
          }
          //setShowErrorPage(true);
        }
        // ✅ Let all other errors pass through to component catch blocks (original design)

        return Promise.reject(error);
      }
    );

  // if (showErrorPage) {
  //   return <ErrorPage />;
  // }

  return (
    <div>
      {/* ToastContainer moved to App.js for global use */}
    </div>
  );
};

export default AppAuthentication;